module.exports = __webpack_public_path__ + "static/media/carousel.33ed7b94.png";